import { render } from "./ChangeUsername.vue?vue&type=template&id=df048942&ts=true"
import script from "./ChangeUsername.vue?vue&type=script&lang=ts"
export * from "./ChangeUsername.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__